import { render, staticRenderFns } from "./DelegationOrderStatusChip.vue?vue&type=template&id=675f3b9b&scoped=true&"
import script from "./DelegationOrderStatusChip.vue?vue&type=script&lang=js&"
export * from "./DelegationOrderStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f3b9b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675f3b9b')) {
      api.createRecord('675f3b9b', component.options)
    } else {
      api.reload('675f3b9b', component.options)
    }
    module.hot.accept("./DelegationOrderStatusChip.vue?vue&type=template&id=675f3b9b&scoped=true&", function () {
      api.rerender('675f3b9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DelegationOrder/DelegationOrderStatusChip.vue"
export default component.exports